export const noticeSwitch = 'notice_switch';
